import { useState } from "react";
import styles from "../IsaacTags.module.scss";
import type ConfirmTagDeletionDialogPropsNew from "./ConfirmTagDeletionDialogPropsNew";
import type ApiResponse from "../../../services/api/types/ApiResponse";
import useTagNewHook from "../../../hooks/useTagNewHook";
import { useDispatch } from "react-redux";
import { removeTag } from "../../../pages/constructionNew/constructionNewSlice";
import { removeTagFromConstruction } from "../../../pages/constructionsNew/constructionsNewSlice";
import IsaacDialog from "../../isaacDialog/IsaacDialog";
import { DefaultButton, DialogFooter, DialogType, PrimaryButton } from "@fluentui/react";


const ConfirmTagDeletionDialogNew: React.FunctionComponent<ConfirmTagDeletionDialogPropsNew> = ({
    isHidden,
    tag,
    constructionId,
    handleDismiss
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [result, setResult] = useState<ApiResponse<void> | undefined>();
    const {deleteTagFromConstruction} = useTagNewHook();
    const dispatch = useDispatch();

    const handleTagDeletion = async (): Promise<void> => {
        setIsLoading(true);

        if (tag && constructionId) {
            const response = await deleteTagFromConstruction(constructionId, [{Value: tag}]);
            setResult(response);

            if (response.success) {
            dispatch(removeTag(tag));
            dispatch(removeTagFromConstruction({tag, constructionId}));
            handleDismiss();
            }
        }

        setIsLoading(false);
    };

    return (
        <IsaacDialog
          isLoading={isLoading}
          isHidden={isHidden}
          successMessage="Tag was successfully removed."
          errorMessage="Tag was not removed."
          error={result?.errors}
          modalProps={{
            titleAriaId: "NewCalculation",
            subtitleAriaId: "mySubTextId",
            isBlocking: true,
            containerClassName: `ms-dialogMainOverride ${styles.deleteDialog}`,
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Remove tag from construction",
            subText: "Are you sure you want to remove tag from construction?",
          }}
          handleDialogDismiss={handleDismiss}>
          <DialogFooter>
            <PrimaryButton onClick={handleTagDeletion} text="Confirm" />
            <DefaultButton onClick={handleDismiss} text="Cancel" />
          </DialogFooter>
        </IsaacDialog>
  );
};

export default ConfirmTagDeletionDialogNew;